import classNames from "classnames/bind";
import { type SyntheticEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./EmbeddedVideoDetails.module.scss";

const cx = classNames.bind(styles);

export interface Props {
  title: string;
  description: string;
}

type Tabs = "overview" | "relatedContent";

const defaultActiveTab: Tabs = "overview";

interface TabContent {
  [key: string]: React.ReactNode;
}

const tabContent = ({ title, description }: Props): TabContent => ({
  overview: (
    <div id="panel-1" role="tabpanel" tabIndex={0} aria-labelledby="tab-1">
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </div>
  ),
  resources: <div id="panel-2" role="tabpanel" tabIndex={0} aria-labelledby="tab-2" />,
});

export const EmbeddedVideoDetails: React.FC<Props> = ({ title, description }) => {
  const { t } = useTranslation(["flows"]);
  const [activeTab, setActiveTab] = useState<Tabs>(defaultActiveTab);

  /* istanbul ignore next */
  const onTabClick = (e: SyntheticEvent) => {
    const tab = e.currentTarget.getAttribute("data-name") as Tabs;
    setActiveTab(tab || defaultActiveTab);
  };

  return (
    <div className={styles.root}>
      <div className={styles.tabs} role="tablist">
        <div
          role="tab"
          tabIndex={0}
          aria-selected={activeTab === "overview"}
          aria-controls="panel-1"
          id="tab-1"
          data-name="overview"
          className={cx(styles.tab, {
            [styles.active]: activeTab === "overview",
          })}
          onClick={onTabClick}
        >
          {t("overview")}
        </div>
      </div>
      <section>{tabContent({ title, description })[activeTab]}</section>
    </div>
  );
};
